module.exports = __webpack_public_path__ + "static/img/banner-2.d7a69ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/advantage/banner-2.png
// module id = w4B+
// module chunks = 1